import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../auth/guard';
import { LayoutComponent } from '../layout/layout.component';
import { RulesComponent } from './rules/rules.component';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { StakesComponent } from './stakes/stakes.component';
import { MarketAnalysisComponent } from './market-analysis/market-analysis.component';
import { BonusListComponent } from './bonus-list/bonus-list.component';
import { RefferAndEarnComponent } from './reffer-and-earn/reffer-and-earn.component';
import { DepositWithdrawComponent } from './deposit-withdraw/deposit-withdraw.component';

const routes: Routes = [
  
  {
    path: "",
    component: LayoutComponent,
    children: [
      {
        path: "deposit",
        component: DepositWithdrawComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "withdraw",
        component: DepositWithdrawComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "profile",
        component: MyProfileComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "change-password",
        component: ChangePasswordComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "stake-setting",
        component: StakesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "rules",
        component: RulesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "market-analysis",
        component: MarketAnalysisComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "bonus-list",
        component: BonusListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "reffer-and-earn",
        component: RefferAndEarnComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: "reports",
    loadChildren: () =>
      import("./reports/reports.module").then((m) => m.ReportsModule),
      canActivate: [AuthGuard],
  },
  {
    path: "",
    loadChildren: () =>
      import("./dashboard/dashboard.module").then((m) => m.DashboardModule),
  },
  {
    path: "",
    loadChildren: () =>
      import("./sports/sports.module").then((m) => m.SportsModule),
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers:[AuthGuard]
})
export class PagesRoutingModule { }
